export type SupportedLocale = 'ar' | 'he' | 'en';

const RTL_LOCALES = new Set<SupportedLocale>(['ar', 'he']);

export const SUPPORTED_LOCALES: SupportedLocale[] = ['ar', 'he', 'en'];
export const DEFAULT_LOCALE: SupportedLocale = 'ar';

export function directionForLocale(locale: string): 'rtl' | 'ltr' {
  const base = locale.split('-')[0];
  if (base && (RTL_LOCALES as Set<string>).has(base)) return 'rtl';
  return 'ltr';
}
